<script setup lang="ts">
import { ref } from 'vue'
import { FilterField } from './table';
import SearchSelect from '../ui/form/SearchSelect.vue';
import NumberInput from '../ui/form/NumberInput.vue';
import TextInput from '../ui/form/TextInput.vue';

const props = defineProps<{
  fields?: FilterField[]
  filteredFields: FilterField[]
}>()

const emit = defineEmits<{
  (e: 'apply', filters: FilterField[]): void
  (e: 'close'): void
}>()

const filters = ref<FilterField[]>(props.fields ? [...props.fields] : [])

const handleApply = () => {
  if (props.fields) {
    emit('apply', props.fields)
  }
}

</script>

<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4">
      <div class="p-6">
        <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4">Filter</h3>
        
        <div class="space-y-4 grid md:grid-cols-2 gap-4">
          <template v-for="(field, index) in fields" :key="field.name">
            <!-- Select Field -->
            <div v-if="field.type === 'select'">
              <SearchSelect
            :options="field.options"
            v-model="filters[index].value"
            :label="field.label" />
            </div>

            <!-- Number Field -->
            <div v-else-if="field.type === 'number'">
              <NumberInput
               type="number"
                :label="field.label"
                v-model="filters[index].value"
                :min="field.min"
                :max="field.max" />
            </div>

            <!-- Range Field -->
            <div v-else-if="field.type === 'range'" class="grid grid-cols-2 gap-4">
              <div>
                <NumberInput
               type="number"
                :label="'Min ' + field.label"
                v-model="filters[index].value"
                :min="field.min"
                :max="field.max" />
              </div>
              <div>
                <NumberInput
               type="number"
                :label="'Max ' + field.label"
                v-model="filters[index].value"
                :min="field.min"
                :max="field.max" />
              </div>
            </div>

            <!-- Text Field -->
            <div v-else>
              <TextInput
                type="text"
                :label="field.label"
                v-model="filters[index].value" />
            </div>
          </template>
          
        </div>
        
        <div class="mt-6 flex justify-end space-x-3">
          <button
            @click="$emit('close')"
            class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            @click="handleApply"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>
</template>